var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button-primary block",on:{"click":_vm.handleTentative}},[_c('span',[_vm._v(_vm._s(_vm.$t('tour_accept_tos')))])])}
var staticRenderFns = []

export { render, staticRenderFns }